import React from 'react';
import { Alert } from 'reactstrap';
var defaultProps = {
  alertText: 'new',
  color: 'info'
};

var FeatureBanner = function FeatureBanner(_ref) {
  var _ref$alertText = _ref.alertText,
      alertText = _ref$alertText === void 0 ? defaultProps.alertText : _ref$alertText,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? defaultProps.color : _ref$color,
      title = _ref.title,
      subtitle = _ref.subtitle,
      children = _ref.children;
  var alertStyle = 'fw-bold text-uppercase';
  return /*#__PURE__*/React.createElement(Alert, {
    color: color,
    className: "align-items-center d-flex p-0",
    fade: false
  }, /*#__PURE__*/React.createElement("h2", {
    className: "".concat(alertStyle, " text-center m-0 px-3 d-none d-sm-block")
  }, alertText), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-row flex-wrap p-3 w-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-fill me-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-inline-block m-0"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "".concat(alertStyle, " d-inline d-sm-none me-2")
  }, alertText), /*#__PURE__*/React.createElement("h3", {
    className: "d-inline"
  }, title)), /*#__PURE__*/React.createElement("p", {
    className: "m-0"
  }, subtitle)), /*#__PURE__*/React.createElement("div", {
    className: "d-inline-block my-auto"
  }, children)));
};

FeatureBanner.displayName = "FeatureBanner";
export default FeatureBanner;